import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const AddOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path transform="translate(5 5)" id="a" d="M13 8H8v5c0 .55-.45 1-1 1s-1-.45-1-1V8H1c-.55 0-1-.45-1-1s.45-1 1-1h5V1c0-.55.45-1 1-1s1 .45 1 1v5h5c.55 0 1 .45 1 1s-.45 1-1 1z" />
  </SvgIcon>
);
